var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.profile
    ? _c(
        "div",
        { staticClass: "starter-page" },
        [
          _c(
            "div",
            {
              staticClass:
                "navbar-dark project-header pt-2 pb-0 px-4 d-flex justify-content-end teestt",
            },
            [
              _c("div", { staticClass: "gantt-title-wrapper" }, [
                false
                  ? _c(
                      "a",
                      {
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.back()
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "icon icon-xs",
                          attrs: {
                            src: require("@/assets/img/icons/svgs/solid/left-arrow.svg"),
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm.profile
                  ? _c(
                      "small",
                      {
                        staticClass:
                          "align-middle d-inline-block ticket-title__client-name px-3 text-primary",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.profile.first_name) +
                            " " +
                            _vm._s(_vm.profile.last_name)
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "span",
                  {
                    staticClass:
                      "align-middle d-inline-flex align-items-center p-0 text-primary",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "text-muted gPrev pr-1",
                        staticStyle: { cursor: "pointer" },
                        on: { click: _vm._onPrevClicked },
                      },
                      [_c("i", { staticClass: "fal fa-angle-left" })]
                    ),
                    _c("small", { staticClass: "text-primary px-1" }, [
                      _vm._v(_vm._s(_vm.formattedDate)),
                    ]),
                    _c(
                      "a",
                      {
                        staticClass: "text-muted gNext pl-1",
                        staticStyle: { cursor: "pointer" },
                        on: { click: _vm._onNextClicked },
                      },
                      [_c("i", { staticClass: "fal fa-angle-right" })]
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "d-flex align-items-center pl-3" }, [
                false
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm text-white bg-info my-2 mt-2 mb-2 ml-2 my-md-0",
                        attrs: {
                          type: "button",
                          "data-toggle": "tooltip",
                          "data-placement": "top",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$router.back()
                          },
                        },
                      },
                      [_vm._v("\n        My Projects\n      ")]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  [
                    _c("flat-picker", {
                      staticClass: "form-control datepicker",
                      attrs: { config: { wrap: true, allowInput: false } },
                      on: {
                        "on-open": () => {},
                        "on-close": () => {},
                        "on-change": () => {
                          this.fetchAllRecords()
                        },
                      },
                      model: {
                        value: _vm.selectedDate,
                        callback: function ($$v) {
                          _vm.selectedDate = $$v
                        },
                        expression: "selectedDate",
                      },
                    }),
                    _c(
                      "a",
                      {
                        staticClass:
                          "nav-link icon-shape icon-shape--25 icon-shape--white icon-sm icn-calendar-nav p-0 timesheet-icon lh-1 d-flex align-items-center justify-content-center bg-light-grey",
                        attrs: {
                          "data-toggle": "",
                          "data-original-title": "Timesheet Entry",
                          "data-target": "offcanvasTimer",
                          "data-offcanvasfrom": "offcanvas",
                        },
                        on: { click: _vm._onCalendarClicked },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "ni ni-calendar-grid-58 icn-calendar-nav",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "d-flex flex-column justify-start" },
            [
              _c(
                "transition",
                { attrs: { name: "slide" } },
                [
                  _vm.tasks
                    ? _c("TimeSheetGantt", {
                        ref: "aa",
                        attrs: {
                          type: "timesheet",
                          currentDate: _vm.selectedDate,
                          ganttView: _vm.ganttView,
                          ganttZoom: _vm.ganttZoom,
                          currency: _vm.profile.currency,
                          tasks: _vm.tasks,
                          "color-class": "timesheetGantt",
                        },
                        on: {
                          "task-link-clicked": _vm.handleTaskLinkClick,
                          dblClickEmptyArea: _vm.handleTaskDblClick,
                          "task-dbl-click": _vm.handleTaskDblClick,
                          "task-dragged": _vm.handleTasDrag,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.tasks && _vm.showEdit
            ? _c(
                "portal",
                { attrs: { to: "sidebar" } },
                [
                  _c("timeline-edit", {
                    attrs: {
                      show: _vm.showEdit,
                      fullWidth: false,
                      timesheet: _vm.data,
                      clickedDate: _vm.selectedDate,
                    },
                    on: {
                      outSideClicked: function ($event) {
                        _vm.showEdit = false
                      },
                      timesheetCreated: _vm.onTimesheetCreated,
                      timesheetUpdated: _vm.onTimesheetUpdated,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }